import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.restoreExpandedState()
  }

  toggleCourse(event) {
    const courseId = event.currentTarget.dataset.courseId
    const courseButton = event.currentTarget
    const modulesList = this.element.querySelector(`ul[data-course-id="${courseId}"]`)
    const toggleIcon = courseButton.querySelector('.toggle-icon')
    
    if (!modulesList) return

    const isExpanded = !modulesList.classList.contains('hidden')
    
    if (isExpanded) {
      // Сворачиваем курс
      modulesList.classList.add('hidden')
      toggleIcon.classList.remove('rotate-90')
      courseButton.classList.remove('expanded')
      this.saveCourseExpandedState(courseId, false)
    } else {
      // Разворачиваем курс
      modulesList.classList.remove('hidden')
      toggleIcon.classList.add('rotate-90')
      courseButton.classList.add('expanded')
      this.saveCourseExpandedState(courseId, true)
    }
  }

  toggleModule(event) {
    const moduleId = event.currentTarget.dataset.moduleId
    const moduleButton = event.currentTarget
    const lessonsList = this.element.querySelector(`ul[data-module-id="${moduleId}"]`)
    const toggleIcon = moduleButton.querySelector('.toggle-icon')
    
    if (!lessonsList) return

    const isExpanded = !lessonsList.classList.contains('hidden')
    
    if (isExpanded) {
      // Сворачиваем модуль
      lessonsList.classList.add('hidden')
      toggleIcon.classList.remove('rotate-90')
      moduleButton.classList.remove('expanded')
      this.saveExpandedState(moduleId, false)
    } else {
      // Разворачиваем модуль
      lessonsList.classList.remove('hidden')
      toggleIcon.classList.add('rotate-90')
      moduleButton.classList.add('expanded')
      this.saveExpandedState(moduleId, true)
    }
  }

  // Сохранение состояния раскрытости курса
  saveCourseExpandedState(courseId, isExpanded) {
    const key = `admin_course_${courseId}_expanded`
    localStorage.setItem(key, isExpanded.toString())
  }

  // Сохранение состояния раскрытости модуля
  saveExpandedState(moduleId, isExpanded) {
    const key = `admin_module_${moduleId}_expanded`
    localStorage.setItem(key, isExpanded.toString())
  }

  // Восстановление состояния раскрытости при загрузке страницы
  restoreExpandedState() {
    // Восстанавливаем состояние курсов
    const courseToggles = this.element.querySelectorAll('.course-toggle')
    courseToggles.forEach(courseToggle => {
      const courseId = courseToggle.dataset.courseId
      const key = `admin_course_${courseId}_expanded`
      const isExpanded = localStorage.getItem(key) === 'true'
      
      const modulesList = this.element.querySelector(`ul[data-course-id="${courseId}"]`)
      const toggleIcon = courseToggle.querySelector('.toggle-icon')
      
      if (isExpanded && modulesList) {
        modulesList.classList.remove('hidden')
        toggleIcon.classList.add('rotate-90')
        courseToggle.classList.add('expanded')
      }
    })

    // Восстанавливаем состояние модулей
    const moduleToggles = this.element.querySelectorAll('.module-toggle')
    moduleToggles.forEach(moduleToggle => {
      const moduleId = moduleToggle.dataset.moduleId
      const key = `admin_module_${moduleId}_expanded`
      const isExpanded = localStorage.getItem(key) === 'true'
      
      const lessonsList = this.element.querySelector(`ul[data-module-id="${moduleId}"]`)
      const toggleIcon = moduleToggle.querySelector('.toggle-icon')
      
      if (isExpanded && lessonsList) {
        lessonsList.classList.remove('hidden')
        toggleIcon.classList.add('rotate-90')
        moduleToggle.classList.add('expanded')
      }
    })
  }
}
